import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cache = null;

export const NotionBestaetigungButton = ({ teilnehmerId, nachname, kurs, idx }) => {
  const [vorlagen, setVorlagen] = useState(cache || []);

  useEffect(() => {
    if (cache) return;
    axios.get(`${API}/teilnahmebestaetigung-vorlagen`).then((r) => { cache = r.data; setVorlagen(r.data); }).catch(() => {});
  }, []);

  const passend = vorlagen.filter((v) => kurs?.kurs_id && v.crm_kurse.includes(kurs.kurs_id));
  const andere = vorlagen.filter((v) => !passend.includes(v));

  const drucken = async (v) => {
    try {
      const params = new URLSearchParams({ vorlage: v.id });
      if (kurs?.kurs_id) params.set("kurs_id", kurs.kurs_id);
      const res = await axios.get(`${API}/teilnehmer/${teilnehmerId}/teilnahmebestaetigung-vorlage-pdf?${params}`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const a = document.createElement("a"); a.href = url;
      a.download = `Teilnahmebestaetigung_${nachname || "TN"}_${v.id}.pdf`;
      document.body.appendChild(a); a.click(); a.remove();
      toast.success("Teilnahmebestätigung heruntergeladen");
    } catch {
      toast.error("Teilnahmebestätigung konnte nicht erstellt werden");
    }
  };

  const eintrag = (v) => (
    <DropdownMenuItem key={v.id} data-testid={`notion-vorlage-${v.id}-${idx}`} onClick={() => drucken(v)}>
      {v.titel}{v.ue ? ` · ${v.ue} UE` : ""}
    </DropdownMenuItem>
  );

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="sm" variant="outline" data-testid={`btn-notion-bestaetigung-${idx}`}
          title="Teilnahmebestätigung nach früherer Notion-Vorlage (ohne AZAV-Wortlaut)">
          Bestätigung (Vorlage)
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="max-h-96 overflow-y-auto">
        {passend.length > 0 && <DropdownMenuLabel>Passend zum Kurs</DropdownMenuLabel>}
        {passend.map(eintrag)}
        {passend.length > 0 && <DropdownMenuSeparator />}
        <DropdownMenuLabel>{passend.length ? "Weitere Vorlagen" : "Vorlage wählen"}</DropdownMenuLabel>
        {andere.map(eintrag)}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
